import React, { useEffect, useState } from "react";
import {DropdownItem, DropdownMenu, DropdownToggle, FormFeedback, FormGroup, Input, Label, UncontrolledDropdown } from "reactstrap";
import Form from 'react-bootstrap/Form'
import { getLocations, getLocationsWithDetail } from "../../../../shared/services/locationApi";
import { getLocation } from "connected-react-router";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

interface AnswerProps {
    onAnswerUpdate: (value: any) => any;
    invalid?: boolean;
    optional?: boolean;
}
interface OptionValueLabel {
    value: number;
    label: string;
}
const getYesNoOptions = () => {
    let o = [
        { value: 1, label: "Yes" },
        { value: 0, label: "No" }
    ] as OptionValueLabel[];
    return o;
}
export const yesNoOptions = getYesNoOptions();

const getTrainBrakeOptions = () => {
    let o = [
        { value: 1, label: "ECPB" },
        { value: 2, label: "PNU" }
    ] as OptionValueLabel[];
    return o;
}
export const trainBrakeOptions = getTrainBrakeOptions();

const getLineOptions = () => {
    let o = [
        { value: 1, label: "East" },
        { value: 2, label: "West" }
    ] as OptionValueLabel[];
    return o;
}
export const lineOptions = getLineOptions();

const getLoadOptions = () => {
    let o = [
        { value: 1, label: "Loaded" },
        { value: 0, label: "Empty" }
    ] as OptionValueLabel[];
    return o;
}
export const loadOptions = getLoadOptions();

const getIncidentOptions = () => {
    let o = [
        { value: 1, label: "Incident" },
        { value: 2, label: "Feedback" },
        { value: 3, label: "ECPB" },
        { value: 4, label: "Leader" },
        { value: 5, label: "Radio" }
    ] as OptionValueLabel[];
    return o;
}
export const incidentOptions = getIncidentOptions();

const getResultOptions = () => {
    let o = [
        { value: 1, label: "Dump" },
        { value: 2, label: "Penalty" },
        { value: 3, label: "Stoppage" },
        { value: 4, label: "Parting" },
        { value: 5, label: "Derailment" }
    ] as OptionValueLabel[];
    return o;
}
export const resultOptions = getResultOptions();

const getRadioOptions = () => {
    let o = [
        { value: 1, label: "Handheld" },
        { value: 2, label: "Loco radio(upper)" },
        { value: 3, label: "Loco radio(lower)" },
        { value: 4, label: "Zone" },
        { value: 5, label: "Channel" }
    ] as OptionValueLabel[];
    return o;
}
export const radioOptions = getRadioOptions();
interface IYesNoProps extends AnswerProps {
    name: string;
}
interface TextInputProps extends AnswerProps {
    placeholder?: string;
    emailValidation?: boolean;
    onMouseOutUpdate?: (value: any) => void;
    emailExist?: boolean;
}
export const SingleLineTextInput = (props: TextInputProps) => {
    const [text, setText] = useState('');
    const maxLength = 100;

    const getValue = (event: any) => {
        return (event?.target?.value || '').substring(0, maxLength) as string;
    }

    const answerUpdate = (event: any) => {
        let value = getValue(event);
        props.onAnswerUpdate(value);
        setText(value);

        if (typeof props.onMouseOutUpdate === 'function') {
            if (value !== "" && props.emailExist) {
                props.onMouseOutUpdate!(value);
            }

            if (value === "" && !props.emailValidation) {
                props.onMouseOutUpdate!(value);
            }
        }
    }

    const mouseOutUpdate = (event: any) => {
        let value = getValue(event);
        if (typeof props.onMouseOutUpdate === 'function' && value !== "" && !props.emailExist) {
            props.onMouseOutUpdate!(value);
        }
    }

    return (
        <>
            <Input
                type="text"
                value={text}
                placeholder={props.placeholder || `Enter text here (max. ${maxLength} characters)`}
                maxLength={maxLength}
                onChange={answerUpdate}
                required={true}
                invalid={props.emailValidation || props.invalid}
                onMouseOut={mouseOutUpdate}
            />
            <FormFeedback>Required</FormFeedback>
        </>
    )
}

export const YesNoCheck = (props: IYesNoProps) => {
    return (
        <>

            <div key={`${props.name}`} className="d-flex flex-wrap align-items-center">
                <Form.Check required type="checkbox" id={`${props.name}`} name={props.name} onChange={props.onAnswerUpdate} className="lead-loco-checkbox" />
            </div>
            <FormFeedback className={`${props.invalid ? "d-block" : ""}`}>Required</FormFeedback>
        </>
    );
}

export const TrainBrakeChoice = (props: IYesNoProps) => {
    return (
        <>
            <div className="d-flex flex-wrap align-items-center">
                {trainBrakeOptions.map((option) => (
                    <Form.Check
                        inline
                        key={`${props.name}_${option.value}`}
                        type="checkbox"
                        id={`${props.name}_${option.value}`}
                        name={props.name}
                        value={option.value}
                        label={option.label}
                        className="mr-3"
                        onChange={props.onAnswerUpdate}
                    />
                ))}
            </div>
            <FormFeedback className={`${props.invalid ? "d-block" : ""}`}>Required</FormFeedback>
        </>
    );
}

export const YesNoChoice = (props: IYesNoProps) => {
    return (
        <>
            <div className="d-flex flex-wrap align-items-center">
                {yesNoOptions.map((option) => (
                    <Form.Check
                        inline
                        key={`${props.name}_${option.value}`}
                        type="radio"
                        id={`${props.name}_${option.value}`}
                        name={props.name}
                        value={option.value}
                        label={option.label}
                        className="mr-3"
                        onChange={props.onAnswerUpdate}
                    />
                ))}
            </div>
            <FormFeedback className={`${props.invalid ? "d-block" : ""}`}>Required</FormFeedback>
        </>
    );
}

export const LineChoice = (props: IYesNoProps) => {
    return (
        <>
            <div className="d-flex flex-wrap align-items-center">
                {lineOptions.map((option) => (
                    <Form.Check
                        inline
                        key={`${props.name}_${option.value}`}
                        type="radio"
                        id={`${props.name}_${option.value}`}
                        name={props.name}
                        value={option.value}
                        label={option.label}
                        className="mr-3"
                        onChange={props.onAnswerUpdate}
                    />
                ))}
            </div>
           
            <FormFeedback className={`${props.invalid ? "d-block" : ""}`}>Required</FormFeedback>
        </>
    );
}

export const LoadChoice = (props: IYesNoProps) => {
    return (
        <>
            <div className="d-flex flex-wrap align-items-center">
                {loadOptions.map((option) => (
                    <Form.Check
                        inline
                        key={`${props.name}_${option.value}`}
                        type="radio"
                        id={`${props.name}_${option.value}`}
                        name={props.name}
                        value={option.value}
                        label={option.label}
                        className="mr-3"
                        onChange={props.onAnswerUpdate}
                    />
                ))}
            </div>
            <FormFeedback className={`${props.invalid ? "d-block" : ""}`}>Required</FormFeedback>
        </>
    );
}

export const IncidentCheck = (props: IYesNoProps) => {
    return (
        <>
            <div className="d-flex flex-wrap align-items-center">
                {incidentOptions.map((option) => (
                    <Form.Check
                        inline
                        key={`${props.name}_${option.value}`}
                        type="checkbox"
                        id={`${props.name}_${option.value}`}
                        name={props.name}
                        value={option.value}
                        label={option.label}
                        className="mr-3"
                        onChange={props.onAnswerUpdate}
                    />
                ))}
            </div>
        </>
    );
}

export const ResultCheck = (props: IYesNoProps) => {
    return (
        <>
            <div className="d-flex flex-wrap align-items-center">
                {resultOptions.map((option) => (
                    <Form.Check
                        inline
                        key={`${props.name}_${option.value}`}
                        type="checkbox"
                        id={`${props.name}_${option.value}`}
                        name={props.name}
                        value={option.value}
                        label={option.label}
                        className="mr-3"
                        onChange={props.onAnswerUpdate}
                    />
                ))}
            </div>
        </>
    );
}

export const RadioCheck = (props: IYesNoProps) => {
    return (
        <>
            <div className="d-flex flex-wrap align-items-center">
                {radioOptions.map((option) => (
                    <Form.Check
                        inline
                        key={`${props.name}_${option.value}`}
                        type="checkbox"
                        id={`${props.name}_${option.value}`}
                        name={props.name}
                        value={option.value}
                        label={option.label}
                        className="mr-3"
                        onChange={props.onAnswerUpdate}
                    />
                ))}
            </div>
        </>
    );
}
export const ECPBPressuresChoice = (props: AnswerProps) => {
    const minDrinks = 0;
    const maxDrinks = 20;
    const maxDrinksMessage = "20 or more";

    const options = () => {
        let drinksOptions = [] as number[];
        for (let drinks = minDrinks; drinks <= maxDrinks; drinks += 1) {
            drinksOptions.push(drinks);
        }

        let mappedOptions = drinksOptions.map(option => ({ value: option, label: displayDrinksChoices(option) }));
        return mappedOptions;
    }

    const displayDrinksChoices = (drinks: number) => {
        if (drinks == maxDrinks) {
            return maxDrinksMessage;
        }
        return `${drinks}`;
    }

    return (
        <DropdownSelect {...props} options={options()} />
    );
}

interface LocationChoiceProps extends AnswerProps {
    defaultLocationId?: number;
}

export const OtherLocation = { value: -2, label: "Other" };
export const LocationChoice = (props: LocationChoiceProps) => {
    const [options, setOptions] = useState([] as OptionValueLabel[]);
    const [selectedAnswer, setSelectedAnswer] = useState(undefined as undefined | OptionValueLabel);


    useEffect(() => {
        let mounted = true;
        const mount = async () => {
            const results = await getLocations();
            if (mounted) {
                let locations = results.filter(location => (location.name ?? "") !== "").map(location => ({ value: location.id, label: `${location.name}` }));
                locations.push(OtherLocation);
                setOptions(locations);
                if (props.defaultLocationId !== undefined) {
                    props.onAnswerUpdate(props.defaultLocationId);
                    let defaultLocationOption = locations.find(l => l.value === props.defaultLocationId);
                    if (defaultLocationOption) {
                        setSelectedAnswer(defaultLocationOption);
                    }
                }
            }
        };


        mount();
        return () => { mounted = false };
    }, []);

    return (
        <DropdownSelect {...props} options={options} selectedAnswer={selectedAnswer} />
    );
}
interface SelectAnswerProps extends AnswerProps {
    options: OptionValueLabel[];
    selectedAnswer?: OptionValueLabel;
}

export const DropdownSelect = (props: SelectAnswerProps) => {
    const [selectedAnswer, setSelectedAnswer] = useState(props.selectedAnswer);

    const answerSelected = (choice: OptionValueLabel) => {
        setSelectedAnswer(choice);
        props.onAnswerUpdate(choice);
    }

    const isOptional = () => props.optional === true; //default to false if not provided

    useEffect(() => {
        // Fixes a bug on safari where dropdown unpopulates
        if (props.selectedAnswer) {
            setSelectedAnswer(props.selectedAnswer);
        }
    }, [props.selectedAnswer]);

    return (
        <div className={`main-form-selector`}>
            <UncontrolledDropdown>
                <DropdownToggle
                    className={`form-control${props.invalid && !isOptional() ? ' is-invalid' : ''}${!selectedAnswer ? ' is-faded' : ''}`}
                    tag="div">
                    <div className="fa-select-options">
                        {selectedAnswer ? selectedAnswer.label : <span className="fa-select-default">Select</span>}
                    </div>
                    <div className="fa-select-button">
                        <ExpandMore className="expanded-show" />
                        <ExpandLess className="expanded-hide" />
                    </div>
                </DropdownToggle>
                <DropdownMenu>
                    {props.options.map((choice) => (
                        <DropdownItem
                            key={choice.value}
                            className={`form-check-inline dropdown-item ${choice.value}`}
                            onClick={() => answerSelected(choice)}>
                            <Label className={`form-check-label`}>{choice.label}</Label>
                        </DropdownItem>
                    ))}
                </DropdownMenu>
            </UncontrolledDropdown>
            <FormFeedback className={`${props.invalid && !isOptional() ? "d-block" : ""}`}>Required</FormFeedback>
        </div>
    );
}
